import {Enums} from '_app/utils';
import apiService from './apiService';
import appConfigService from './appConfigService';

export default (function () {

	var FILE_TYPE_ICONS = {
		mp3: 'volume-up', wav: 'volume-up',
		jpg: 'file-image-o', gif: 'file-image-o', png: 'file-image-o', bmp: 'file-image-o',
		mp4: 'video-camera', mov: 'video-camera', m4v: 'video-camera',
		pdf: 'file-pdf-o',
		xls: 'file-excel-o',
		ppt: 'file-powerpoint-o',
		doc: 'file-word-o',
		docx: 'file-word-o',
		docm: 'file-word-o',
		zip: 'file-zip-o',
		txt: 'file-text-o',
		one: 'file-o',
		css: 'css3',
		exe: 'cube',
		info: 'bar-chart',
		html: 'html5',
		def: 'question-circle-o',
		mail: 'envelope-o',
		epub: 'book', mobi: 'book', kf8: 'book',
		news: 'newspaper-o'
	};

	function iconFromFileType(fileType) {
		var iconName = FILE_TYPE_ICONS[fileType];

		if (!iconName) {
			iconName = FILE_TYPE_ICONS.def;
		}
		return iconName;
	}

	function iconFromMedia(media) {
		if (media.FileType) {
			return iconFromFileType(media.FileType);
		} else {
			return iconFromFileType(fileTypeFromMedia(media));
		}
	}

	function iconDecoratorForSource(code) {
		var result = null;

		if (!code) {
			return result;
		}

		const mediaSources = Enums.getType('mediaSources');

		switch (code) {
			case mediaSources.FMEX:
				return 'fmex_icon.png';
			default:
				return null;
		}
	}

	function fileTypeFromMedia(media) {
		if (media) {
			const mediaTypes = Enums.getType('mediaTypes');
			const mediaClass = Enums.getType('mediaClass');
			const clazz = classFromType(media.Type);

			switch (clazz) {
				case mediaClass.VIDEO:
					return 'mp4';
				case mediaClass.PRESENTATION:
					return 'exe';
				case mediaClass.PRINT:
					switch (media.Type) {
						case mediaTypes.EBOOK:
							return 'epub';
						case mediaTypes.INFOGRAPHIC:
							return 'info';
						case mediaTypes.ONESHEET:
							return 'one';
						default:
							return 'pdf';
					}
				case mediaClass.AUDIO:
					return 'mp3';
				case mediaClass.EMAIL:
					return 'mail';
				case mediaClass.NEWSLETTER:
					return 'news';
				default:
					return 'def';
			}
		}
		return 'def';
	}

	function isFileTypeViewable(type) {
		switch (type) {
			case 'jpg':
			case 'gif':
			case 'png':
			case 'bmp':
			case 'pdf':
			case 'txt':
			case 'one':
			case 'css':
			case 'html':
			case 'mail':
				return true;
			default:
				return false;
		}
	}

	function classFromType(mediaType) {
		var mediaTypes = Enums.getType('mediaTypes');
		var mediaClass = Enums.getType('mediaClass');

		switch (mediaType) {
			case mediaTypes.VIDEO:
				return mediaClass.VIDEO;
			case mediaTypes.PRESENTATION:
				return mediaClass.PRESENTATION;
			case mediaTypes.ARTICLE:
			case mediaTypes.EBOOK:
			case mediaTypes.INFOGRAPHIC:
			case mediaTypes.ONESHEET:
				return mediaClass.PRINT;
			case mediaTypes.AUDIO:
				return mediaClass.AUDIO;
			case mediaTypes.EMAIL:
				return mediaClass.EMAIL;
			case mediaTypes.NEWSLETTER:
				return mediaClass.NEWSLETTER;
		}
		return mediaClass.UNKNOWN;
	}

	function storedFileUrl(storedFile) {
		return apiService.rootUrl() + '/StoredFile/' + storedFile
				+ '/download';
	}

	function storedFileDownloadUrl(storedFile) {
		return storedFileUrl(storedFile) + '?downloadFile=true';
	}

	function mediaDownloadUrl(media) {
		var mediaTypes = Enums.getType('mediaTypes');

		switch (media.Type) {
			case mediaTypes.AUDIO:
				return media.ConversionName;
			case mediaTypes.VIDEO:
				return media.ConversionName;
			default:
				return storedFileDownloadUrl(media.ExternalMediaID);
		}
	}

	function videoThumbnail(externalMediaId, size) {
		return appConfigService.get('videoContentUrl') + 'thumbs/' + externalMediaId
				+ '-' + size + '.jpg';
	}

	function videoUrl(externalMediaId) {
		return appConfigService.get('videoContentUrl') + 'manifests/' + externalMediaId + '.m3u8';
	}

	function videoTrackUrl(keyText) {
		return appConfigService.get('videoContentUrl') + 'tracks/' + keyText + '.vtt';
	}

	function thumbnailUrl(mediaType, thumbnailLink, externalMediaId) {
		if (!thumbnailLink && !externalMediaId) {
			return null; // No custom thumbnail possible
		}
		let result = null;

		if (thumbnailLink && thumbnailLink.length) {
			result = storedFileUrl(thumbnailLink);
		} else if (mediaType === Enums.getType('mediaTypes').VIDEO && externalMediaId) {
			const size = '320';

			result = videoThumbnail(externalMediaId, size);
		}
		return result;
	}

	function mimeFromType(mediaType) {
		var mediaTypes = Enums.getType('mediaTypes');

		switch (mediaType) {
			case mediaTypes.VIDEO:
				return 'video/mp4,video/mov,video/avi,video/wmv,video/mpeg';
			case mediaTypes.AUDIO:
				return 'audio/mp3,audio/ogg,audio/wav';
			case mediaTypes.EBOOK:
				return 'application/pdf,application/vnd.amazon.ebook,application/x-mobipocket-ebook,application/epub+zip';
			case mediaTypes.INFOGRAPHIC:
				return 'image/gif,image/png,image/jpeg,image/bmp';
			default:
				return 'application/pdf,application/msword,application/xml,text/plain,application/vnd.ms-powerpoint,text/html';
		}
	}

	function getCustomFileImage(fileType) {
		switch (fileType) {
			case 0:
			case 1:
				return '/Content/unknown.png';
			case 2:
				return '/Content/pdf.png';
			case 3:
			case 4:
			case 5:
				return '/Content/no_thumb.png';
			case 6:
			case 7:
			case 8:
				return '/Content/word.png';//TODO: Needs update for doc
			case 9:
				return '/Content/no_thumb.png';
			case 10:
			case 11:
				return '/Content/spreadsheet.png';
			case 12:
			case 13:
				return '/Content/presentation.png';
			default:
				return '/Content/unknown.png';
		}
	}

	return {
		iconDecoratorForSource: iconDecoratorForSource,
		iconFromFileType: iconFromFileType,
		iconFromMedia: iconFromMedia,
		fileTypeFromMedia: fileTypeFromMedia,
		classFromType: classFromType,
		isFileTypeViewable: isFileTypeViewable,
		mediaDownloadUrl: mediaDownloadUrl,
		storedFileUrl: storedFileUrl,
		storedFileDownloadUrl: storedFileDownloadUrl,
		thumbnailUrl: thumbnailUrl,
		videoTrackUrl: videoTrackUrl,
		videoUrl: videoUrl,
		mimeFromType: mimeFromType,
		getCustomFileImage: getCustomFileImage
	};
}());